export default __webpack_public_path__ + "static/media/watch.a8b7519c.png";